import {
  BrandType,
  CountryType,
  DocumentFormatType,
  DocumentType,
  EmailType,
  EntryPointType,
  PhoneCountryCodeType,
  ProductType,
  SignatureType
} from '@bus/models';

export type DataStorageObject = {
  id: string;
  data: DataStorageData;
  brand: BrandType;
  product: ProductType;
  country: CountryType;
  entryPoint: EntryPointType;
};

export interface VehicleData {
  model: {
    name: string;
  };
}

export type DataStorageData = {
  transaction: Transaction;
  customerData: CustomerData;
  financialProduct: FinancialProduct;
  custom: CustomData;
  vehicleData: VehicleData;
};

export type Transaction = {
  id: string;
  status: TransactionStatus;
  interactionManagementStatus: TransactionStatus;
  links: Link[];
};

export interface Link {
  linkType?: 'REDIRECT_BRAND' | string;
  type?: string;
  url: string;
}

export enum TransactionStatus {
  LEGITIMATION_INITIALIZED = 'LEGITIMATION_INITIALIZED',
  LEGITIMATION_DIGITAL_CONDUCTED = 'LEGITIMATION_DIGITAL_CONDUCTED',
  LEGITIMATION_CONDUCTED = 'LEGITIMATION_CONDUCTED',
  DOCUMENTS_UPLOADED = 'DOCUMENTS_UPLOADED',
  ACCEPTED = 'ACCEPTED',
  TRANSACTION_EXPIRED = 'TRANSACTION_EXPIRED',
  CANCELED = 'CANCELED'
}

export enum CustomerType {
  INDIVIDUAL = 'INDIVIDUAL',
  LEGAL_ENTITY = 'LEGAL_ENTITY'
}

export type CustomerData = {
  customerType: CustomerType;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  contactData: ContactData;
};

export type ContactData = {
  emails: Email[];
  mobilePhoneCountryCode?: PhoneCountryCodeType;
  mobilePhoneNumber?: string;
};

export type Email = {
  type: EmailType;
  emailAddress: string;
};

export type FinancialProduct = {
  contracts: [Contract];
};

export type ContractDocumentFile = {
  filename: string;
  size: number;
};

export type ContractDocumentCategory = {
  customCategoryCode: string;
  customCategoryName: string;
  customCategoryDescription: string;
  customCategoryDisplayLabel: string;
  customCategorySupplementaryText: string;
};

export type ContractDocument = ContractDocumentCategory & {
  // Requested files fields
  customDocumentId: string;
  customDocumentCode: string;
  displayLabel: string;
  description: string;

  // Fields of extended files
  file: ContractDocumentFile;
  fileId: string;
  documentType: DocumentType.UPLOADS;
  documentFormat: DocumentFormatType.PDF;
  signatureType: SignatureType.NO_SIGNATURE;
};

export type Contract = {
  documents: ContractDocument[];
};

export enum ConnectOnlineEventType {
  COMPLETE = 'COMPLETE',
  LEGITIMATION_START_FAILED = 'LEGITIMATION_START_FAILED',
  LEGITIMATION_GET_RESULT_FAILED = 'LEGITIMATION_GET_RESULT_FAILED',
  LEGITIMATION_SAVE_RESULT_FAILED = 'LEGITIMATION_SAVE_RESULT_FAILED',
  LEGITIMATION_SEND_TO_COL_FAILED = 'LEGITIMATION_SEND_TO_COL_FAILED',
  UPLOADED_DOCS_SAVE_FAILED = 'UPLOADED_DOCS_SAVE_FAILED',
  UPLOADED_DOCS_RETRIEVE_FAILED = 'UPLOADED_DOCS_RETRIEVE_FAILED',
  UPLOADED_DOCS_SEND_TO_COL_FAILED = 'UPLOADED_DOCS_SEND_TO_COL_FAILED',
  EXPIRED = 'EXPIRED'
}

export type CustomData = {
  requestInfoType: 'ID' | 'IDDOCS';
  connectOnlineEventType: ConnectOnlineEventType;
  identSignTransaction: any; // TODO
  cvuLegitimationResultSent: boolean;
  cvuUploadsSent: boolean;
  error: string;
  legitimation?: {
    redirectUrl: string;
  };
};
